import { useCallback, useState, type FC } from 'react'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'

import { Text } from 'components'

import AccordionItem from './AccordionItem'
import { heroItems } from './utils'
import styles from './Hero.module.scss'

const Hero: FC = () => {
  const navigate = useNavigate()
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const handleLearnMore = useCallback(() => {
    navigate('/about-us')
  }, [navigate])

  return (
    <section className={styles.hero}>
      <div className={styles.hero__media} aria-hidden>
        <img src={`${process.env.PUBLIC_URL}/home.png`} alt='' className={styles.hero__media_image} />
        <div className={styles.hero__media_overlay} />
      </div>

      <div className={classNames('container', styles.hero__inner)}>
        <div className={styles.hero__intro}>
          <span className={styles.hero__kicker} aria-hidden />
          <Text text='welcomeToKansolut' className={styles.hero__title} tagName='h1' />
          <Text text='whyChooseUsSubtitle' className={styles.hero__subtitle} />
          <button className={styles.hero__cta} onClick={handleLearnMore}>
            <Text text='moreAboutUs' />
            <span className={styles.hero__cta_arrow} aria-hidden />
          </button>
        </div>

        <div className={styles.hero__items}>
          {heroItems.map((item, index) => (
            <AccordionItem
              key={item.title}
              title={item.title}
              content={item.content}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Hero
